import type { CreativeCredit } from 'sr-types/lib/shortlist/v1/graphql';

/**
 * Stable key for list selection, chips, dedupe, Autocomplete equality, and import matching.
 * Distinguishes multiple `CreativeCredit` rows for the same show (different roles, dates, etc.).
 */
function sortedRolesKey(roles: ReadonlyArray<string | null | undefined> | null | undefined): string {
    return [...(roles || [])].filter(Boolean).sort().join('|');
}

function creditRowIdentitySuffix(credit: CreativeCredit): string {
    const roles = sortedRolesKey(credit.professionalRoles);
    const dr = credit.dateRange;
    const rangeKey = `${dr?.start ?? ''}\u001f${dr?.end ?? ''}`;
    const dept = (credit.department || '').trim();
    const showType = (credit.showType || '').trim();
    const locLabel = (credit.location?.label || '').trim();
    return `${roles}\u001e${rangeKey}\u001e${dept}\u001e${showType}\u001e${locLabel}`;
}

function withSourceIndex(key: string, index?: number): string {
    return index !== undefined ? `${key}@${index}` : key;
}

export function getCreditKey(credit: CreativeCredit | null | undefined, index?: number): string {
    if (!credit) return withSourceIndex(`idx-0`, index);
    const suffix = creditRowIdentitySuffix(credit);
    if (credit.showReference?.id) {
        const refType = credit.showReference.type || '';
        return withSourceIndex(`ref:${credit.showReference.id}:${refType}\u001e${suffix}`, index);
    }
    const name = (credit.showName || credit.showReference?.label || '').trim();
    return name ? withSourceIndex(`name:${name}\u001e${suffix}`, index) : withSourceIndex(`idx-0`, index);
}
